import React, { useEffect } from "react"
import { Box, styled } from "@mui/material"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { selectFetchStatus } from "redux/features/payment_schedule/paymentScheduleSlice"
import { makeSignPaymentSchedule } from "redux/features/payment_schedule/paymentScheduleSignThunk"
import { Progress } from "components/ui/Spinner"
import { SIMPLE_SIGN_METHOD } from "config"

type Props = {
  paymentScheduleId: string
  onFailure: () => void
  onSuccess: () => void
}

const SimpleSignComponent = ({
  paymentScheduleId,
  onFailure,
  onSuccess,
}: Props) => {
  const dispatch = useAppDispatch()

  const fetchStatus = useAppSelector((state) => selectFetchStatus(state))

  const handleSubmit = () => {
    const params = {
      payment_schedule_id: paymentScheduleId,
      signing_method: SIMPLE_SIGN_METHOD,
    }

    dispatch(makeSignPaymentSchedule(params))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onFailure()
      })
  }

  useEffect(() => {
    if (!fetchStatus.isFetching) {
      handleSubmit()
    }
  }, [])

  return (
    <Container>
      <Progress color="primary" />
    </Container>
  )
}

export default SimpleSignComponent

const Container = styled(Box)`
  display: flex;
  align-self: center;
  justify-content: center;
  padding: 100px;
  width: 100%;
`
